import React from "react";
import {Layout} from "./Layout";

export const Landing = () => {


  return (<><Layout/></>);
};
